// Peoria Charter — static application configuration, same shape as config/r3.js.
//
// Listed so a Movorra super-admin can see and open every company's applications. Peoria's routes, groups,
// and behaviour are unchanged; this only describes them. Peoria staff groups are deliberately disjoint from
// R3's (movorra-api also rejects any peoria_* identity on the R3 API — PeoriaApiIsolationAuthorizationManager).

export const PEORIA_OPS_GROUPS = ['peoria_operations', 'peoria_admin'];
export const PEORIA_CUSTOMER_GROUPS = ['peoria_customer'];
export const PEORIA_AGENT_TEAM = 'peoria_charter_desk';
export const PEORIA_AGENT = 'charter_quote_agent';

const BRANDING = {
  companyName: 'Peoria Charter', subtitle: 'CHARTER QUOTES', logoSrc: '/peoria-charter-logo.svg', isCharter: true,
};

export function buildPeoriaCompany() {
  return {
    tenantId: 'peoria',
    displayName: 'Peoria Charter',
    branding: BRANDING,
    applications: [
      {
        appId: 'peoria-dispatch',
        type: 'charter-dispatch',
        route: '/peoriaops',
        aliases: ['/charterops', '/quoterequests'],
        displayName: 'Quote Requests',
        description: 'Charter quote-request board for Peoria dispatchers.',
        icon: 'route',
        access: { public: false, identityPool: 'rideshare', anyOfGroups: PEORIA_OPS_GROUPS },
        runtime: { engine: 'movorra-api' },
        capabilities: {},
        records: { studio: false },
        status: { configured: true },
      },
      {
        appId: 'peoria-config',
        type: 'charter-config',
        route: '/peoriaconfig',
        aliases: ['/charterconfig'],
        displayName: 'Charter Configuration',
        description: 'Pricing and service configuration for Peoria Charter.',
        icon: 'building',
        access: { public: false, identityPool: 'rideshare', anyOfGroups: PEORIA_OPS_GROUPS },
        runtime: { engine: 'movorra-api' },
        capabilities: {},
        records: { studio: false },
        status: { configured: true },
      },
      {
        appId: 'peoria-chat',
        type: 'agent-chat',
        route: '/peoriachat',
        aliases: [],
        displayName: 'Charter Quote Chat',
        description: 'Customer charter quote chat on the agents service. Not recorded in Studio.',
        icon: 'chat',
        access: { public: false, identityPool: 'rideshare', anyOfGroups: PEORIA_CUSTOMER_GROUPS },
        runtime: { engine: 'agents', teamId: PEORIA_AGENT_TEAM, agentId: PEORIA_AGENT },
        capabilities: {},
        records: { studio: false },
        status: { configured: true },
      },
    ],
    runtimeKeys: {},
  };
}
